import React, { useEffect, useState, useContext } from 'react'
import BackButton from '../components/BackButton'
import { Swiper, SwiperSlide } from 'swiper/react';
import { handleRedirect, UploadTalkingPhoto } from '../Script'
import { getCachedData , UpdateExpiredTalkingPhoto} from '../Firebase'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { uploadPhotoFirebase, getUploads, UpdateUserLimits } from '../Firebase'
import camera from '../assets/icons8-camera-50.png'
import 'swiper/css';

import { AuthContext } from '../AuthContext';


export default function TalkingPhoto() {

        const { isAuthorized, pageLoader, alert, setAlert } = useContext(AuthContext);

        
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [talkingphoto, setTalkingPhotos] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isUploadLoading, setIsUploadLoading] = useState(false);
    const [isGetUploadLoading, setIsGetUploadLoading] = useState(false);
    const [uploads, setUploads] = useState(false);
    const [userData, setUserData] = useState()

    const [alertMessaeg, setAlertMessage] = useState("")
    const [alertType, setAlertType] = useState("")
    const [isAlertOpen, setIsAlertOpen] = useState("")

    const [selectedImage, setSelectedImage] = useState(null);


    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };


    const fetchData = async () => {
        try {
            setIsGetUploadLoading(true)
            setIsLoading(true);

            const images = await getUploads();
            if (images) {
                setUploads(images);
            } else {
                setUploads([]);
            }
            setIsGetUploadLoading(false)

            //const photos = await getTalkingPhotoList();
            const photos = await getCachedData("talking_photos");
            setTalkingPhotos(photos);
            UpdateExpiredTalkingPhoto()

        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {

        const session = JSON.parse(localStorage.getItem("AI_UserData"))
        setUserData(session)

        fetchData();
    }, []); // Runs only on mount


    const closeAlert = () => {
        setIsAlertOpen("");
    };



    const handleFileChange = async (event) => {

        if (userData.upload_limit === 0) {
            handleOk()
            setAlertMessage("You have reached your upload limit !")
            setAlertType("danger")
            setIsAlertOpen("show")
        } else {
            setIsUploadLoading(true);
            const file = event.target.files[0];

            if (file) {
                const UploadResponse = await UploadTalkingPhoto(file);
                console.log("IMAGE upload response : ", UploadResponse.code);
                console.log("upload response : ", UploadResponse);

                if (UploadResponse.code != 100) {
                    setAlertMessage(UploadResponse.message)
                    setAlertType("success")
                    setIsAlertOpen("show")
                } else {

                    uploadPhotoFirebase(UploadResponse.data);

                    UpdateUserLimits("upload_limit", userData.phone)

                    let existingUploads = sessionStorage.getItem("AI_Uploads");
                    existingUploads = existingUploads ? JSON.parse(existingUploads) : []; // Parse JSON or create empty array

                    existingUploads.unshift({
                        id: UploadResponse.data.talking_photo_id,
                        image_url: UploadResponse.data.talking_photo_url
                    });

                    sessionStorage.setItem("AI_Uploads", JSON.stringify(existingUploads));

                    setUploads(existingUploads); // No need to re-fetch from sessionStorage, use the updated array
                }

                setIsUploadLoading(false);
                handleOk();
            }
        }
    };




    return (
        <>
            <div className=' pt-4 ' style={{ marginBottom: "12rem" }} >

                <div className='container' data-aos='fade-down'>
                    <BackButton title="Talking Photos" />

                    {isAlertOpen ?
                        <div className={`alert alert-${alertType} alert-dismissible fade show`} data-aos='fade-right' role="alert">
                            <h3>{alertMessaeg}</h3>
                            <button type="button" class="btn-close" aria-label="Close" onClick={() => closeAlert()}></button>
                        </div> : ""}
                </div>





                <Swiper
                    className={window.innerWidth > 720 ? 'container' : 'ma-container'} data-aos="fade-down"

                    spaceBetween={0}
                    slidesPerView={3}>


                    <SwiperSlide className='card-small' onClick={showModal}>
                        <img style={{ width: '35px' }} src={camera} />
                        <h2 className='mt-1' >Add Photo</h2>
                    </SwiperSlide>

                    {isGetUploadLoading ? (
                        <SwiperSlide className='card-small card-small-skeleton' onClick={showModal}>
                            <img style={{ width: '35px' }}  />
                            {/* <h2 className='mt-1' ></h2> */}
                        </SwiperSlide>
                    ) : (
                        uploads && uploads.length > 0 ? (
                            uploads.map((item, index) => (
                                <SwiperSlide className="card-small" key={index} onClick={() => handleRedirect(item, 'talking_photo')}>
                                    <img className='slider_image' src={item.image_url} alt={`Upload ${index}`} />
                                </SwiperSlide>
                            ))
                        ) : (
                            ""  // Message when there are no uploads
                        )
                    )


                    }
                </Swiper>

                <div className='container mt-6' >
                    <h1 className='mb-2'>Available Talking Photos</h1>

                    <div className='photo-grid' data-aos='fade-up'>
                        {isLoading ? (
                            // Show skeletons while loading
                            Array(6)
                                .fill(0)
                                .map((_, index) => (
                                    <div key={index} className='skeleton-square'></div>
                                ))
                        ) : talkingphoto && talkingphoto.length > 0 ? (
                            // Show images when loaded
                            talkingphoto.map((photo, index) => (
                                <LazyLoadImage
                                    key={index}
                                    onClick={() => handleRedirect(photo, 'talking_photo')}
                                    src={photo.image_url}
                                    alt={`Photo ${index}`}
                                    loading='lazy'
                                />
                            ))
                        ) : (
                            ""
                        )}
                    </div>



                </div>



            </div>

            {isModalOpen ?
                <div className='modal-div'>
                    <div className='bottom-modal'>
                        <h2
                            className='pr-4 py-2'
                            style={{ textAlign: 'right', cursor: 'pointer' }}
                            onClick={() => handleOk()}
                        >
                            ✖
                        </h2>
                        <div className='container d-flex flex-column gap-4 pb-4'>
                            {/* Open Camera */}
                            <label
                                htmlFor="cameraInput"
                                className="button-modal bold"
                                style={{ background: '#8080802b', cursor: 'pointer' }}
                            >
                                <h2>Take Photo</h2>
                            </label>
                            <input
                                id="cameraInput"
                                type="file"
                                accept="image/*"
                                capture="environment" // Opens the camera on mobile devices
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                            />

                            {/* Upload from Gallery */}
                            <label
                                htmlFor="galleryInput"
                                className="button-modal bold"
                                style={{
                                    background: 'black', // Faded background when loading
                                    color: isUploadLoading ? '#aaa' : 'white', // Lighter text color when loading
                                    cursor: isUploadLoading ? 'not-allowed' : 'pointer', // Disable pointer when loading
                                    pointerEvents: isUploadLoading ? 'none' : 'auto', // Prevent interaction when loading
                                    opacity: isUploadLoading ? 0.7 : 1, // Slight transparency when loading
                                }}
                            >
                                {isUploadLoading ? <h2>Uploading ...</h2> : <h2>Upload From Gallery</h2>}
                            </label>


                            <input
                                id="galleryInput"
                                type="file"
                                accept="image/*"
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                            />
                        </div>
                    </div>
                </div>

                : ''}
        </>
    )
}
